"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountMethods = exports.Account = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Represents an entry in the "accounts" table.
 */
var AccountMethods = /*#__PURE__*/function () {
  function AccountMethods() {
    _classCallCheck(this, AccountMethods);
  }

  _createClass(AccountMethods, null, [{
    key: "getLogo",
    value: function getLogo(account) {
      var tap2shop = account.extra_fields && 'tap2shop' in account.extra_fields && _typeof(account.extra_fields.tap2shop) === 'object' ? account.extra_fields.tap2shop : undefined;
      var logo = tap2shop && 'logo' in tap2shop && typeof tap2shop.logo === 'string' ? tap2shop.logo : undefined;
      return logo;
    }
  }]);

  return AccountMethods;
}();
/**
 * @deprecated - use the account methods instead
 */


exports.AccountMethods = AccountMethods;

var Account = /*#__PURE__*/function () {
  function Account(data) {
    _classCallCheck(this, Account);

    Object.assign(this, data);
  }

  _createClass(Account, [{
    key: "getLogo",
    value: function getLogo() {
      var _this$extra_fields, _this$extra_fields$ta;

      return (_this$extra_fields = this.extra_fields) === null || _this$extra_fields === void 0 ? void 0 : (_this$extra_fields$ta = _this$extra_fields.tap2shop) === null || _this$extra_fields$ta === void 0 ? void 0 : _this$extra_fields$ta.small_logo;
    }
  }]);

  return Account;
}();

exports.Account = Account;